import React from 'react';
import Badge from '../Badge';

interface Tag {
    id: number;
    name: string;
    slug: string;
    icon: string;
}

interface TagsGroup {
    id: number;
    name: string;
    slug: string;
    visible: boolean;
    tags?: Tag[];
}

interface Product {
    tags?: TagsGroup[];
}

interface BoxContentTagsProps {
    product: Product;
}

const BoxContentTags = ({ product }: BoxContentTagsProps) => {

    if (product?.tags?.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-wrap gap-1">
            {product?.tags
                ?.map((tag) => {
                    return (
                        <Badge key={tag.id} type='tag'>
                            {/* {tag?.icon && <img src={tag.icon} alt={tag.name} className="w-3 h-3" />} */}
                            {tag.name}
                        </Badge>
                    )
            })}
        </div>
    )
}

export default BoxContentTags;
